export default __webpack_public_path__ + "static/media/calendar.8e46e1dd.svg";